import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from "rxjs/operators";
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-undo',
    templateUrl: './toolbar-button-undo.component.html',
    styleUrls: ['./toolbar-button-undo.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonUndoComponent {
    private readonly store: Store = inject(Store);

    @Input() matIconName = 'undo';
    @Input() fontSet = '';

    readonly isDisabled$ = this.store.select(
        fromToolbar.isUndoButtonActivateable
    ).pipe(
        map(isActivateable => !isActivateable),
    );

    public undo() {
        this.store.dispatch(ToolbarActions.toolbarUndo());
    }
}
